import type { ReactNode } from 'react'
import { createContext } from 'react'
import { FronteggProvider, useAuth } from '@frontegg/react'

import type { User } from '@/types/user'
import { config } from '@/config'

import type { UserContextValue } from '../types'

export const UserContext = createContext<UserContextValue | undefined>(undefined)

export interface UserProviderProps {
	children: ReactNode
}

function UserProviderImpl({ children }: UserProviderProps) {
	const { user, error, isLoading } = useAuth()

	const contextUser: User = {
		id: user?.id ?? '',
		name: user?.name ?? '',
		email: user?.email ?? '',
		avatar: user?.profilePictureUrl ?? '',
	}

	return (
		<UserContext.Provider
			value={{
				user: user ? contextUser : null,
				error: error as string,
				isLoading,
			}}
		>
			{children}
		</UserContext.Provider>
	)
}

export function UserProvider({ children }: UserProviderProps) {
	return (
		<FronteggProvider
			authOptions={{
				keepSessionAlive: true,
			}}
			contextOptions={{
				baseUrl: config.frontegg.baseUrl!,
				clientId: config.frontegg.clientId!,
			}}
			hostedLoginBox
		>
			<UserProviderImpl>{children}</UserProviderImpl>
		</FronteggProvider>
	)
}

export const UserConsumer = UserContext.Consumer
